import React from 'react';
import { all_routes } from '../../../router/all_routes';
import { Link } from 'react-router-dom';
import CollapseHeader from "../../../../core/common/collapse-header";
import { checkPermission } from '../../../../core/permissons/CheckPermissons';

const route = all_routes;

const navItems1 = [
    { label: "Booking Dashboard", icon: "ti-dashboard", link:route.booking , permission: "ADMINISTRATION_ACCESS" },
    { label: "New Booking", icon: "ti-plus", link: route.newBooking, permission: "ROLE_ADD_VEHICLE_BOOKING" },
    { label: "Recurring Booking", icon: "ti ti-repeat", link: route.recurringBooking, permission: "ROLE_ADD_RECURRING_BOOKING" },
    { label: "Pending Approval", icon: "ti ti-clock", link: route.pendingApproval, permission: "ROLE_APPROVE_VEHICLE_BOOKING" },
    { label: "Final Approve", icon: "ti ti-check", link: route.finalApprove, permission: "ROLE_FINAL_APPROVE_VEHICLE_BOOKING" }
];


const PendingApproval: React.FC = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
      <div className="row">
        <div className="col-md-12">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Vehicle Management - Vehicle Booking</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    <CollapseHeader />
                                </div>
                            </div>
                        </div>
                    </div>
        <div className="card">
          <div className="card-body pb-0 pt-2">
          <ul className="nav nav-tabs nav-tabs-bottom" style={{ gap: "12px", display: "flex" }}>
            {navItems1.map((item, index) =>
            item.permission && checkPermission(item.permission) ? (
              <li className="nav-item me-item" key={index}>
              <Link
                to={item.link}
                className={`nav-link px-0 ${index === 3 ? "active" : ""}`}
              >
                <i className={item.icon}></i> {item.label}
              </Link>
              </li>
            ) : null
            )}
          </ul>
          </div>
        </div>
        </div>
      </div>
        <div>
          <h1>Pending Approve</h1>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;

